<template>
  <el-upload :action="'#'" :http-request="onFileUpload" :accept="fileTypes == null ? '' : fileTypes.join(',')"
             :show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="true">
    <slot></slot>
  </el-upload>
</template>

<script>
import {FileUploadUtil} from '@/utils/FileUploadUtil'
import SparkMD5 from 'spark-md5';
import {imageThumbnail, videoThumbnail} from "@/utils/imageUtil";

export default {
  name: "fileUpload",
  data() {
    return {
      loading: null,
      uploadHeaders: {
        "accessToken": sessionStorage.getItem('accessToken')
      },
      uploadingFiles: {}, // fileId -> 文件信息: null,
      fileUploader: null,
      start: 0
    }
  },
  props: {
    action: {
      type: String,
      required: false
    },
    fileTypes: {
      type: Array,
      default: null
    },
    mType: {
      type: String,
      required: true
    },
    maxSize: {
      type: Number,
      default: null
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    isPermanent: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async onFileUpload(file) {
      console.log('onFileUpload',file)
	  const rawFile = file.file || file; 
	  let localFileUrl = '';
	  
	  // 1. 判断是否在 Electron 环境
	  if (window.electronAPI && typeof window.electronAPI.invoke === 'function') {
	    // Electron 端：继续走原有的本地文件复制逻辑
	    const tempFilePath = await window.electronAPI.invoke('copy-file-to-temp', {
	  	path: rawFile.path,
	  	name: rawFile.name,
	  	fileType: this.mType
	    });
	    localFileUrl = `file:///${tempFilePath.replace(/\\/g, '/')}`;
	  } else {
	    // 2. Web 浏览器端：使用原生 Blob URL
	    // 注意：如果是用饿了么等组件库，rawFile 必须是原生的 File 对象
	    localFileUrl = URL.createObjectURL(rawFile);
	  }
	  
	  let data = {
	    localFile: localFileUrl,
	  };
      let msgInfo = JSON.parse(JSON.stringify(file.file));
      Object.assign(data, msgInfo.content);

      console.log('onFileUpload------',file)

      // this.testProtocols(file)
      if (this.mType === 'image') {
        this.onImageUpload(file);
      } else if(this.mType === 'video') {
        this.onChunckUpload(file);
      }else {
        this.onChunckUpload(file);
      }
    },
    // 在渲染进程中创建测试页面
    async testProtocols(file) {
      console.log('开始测试协议...')

      const filePath = file.file.path

      // 测试不同的URL格式
      const testUrls = [
        // local协议
        // `local://${encodeURIComponent(filePath)}`,
        // `local://${encodeURI(filePath.replace(/\\/g, '/'))}`,

        // file协议
        `file:///${filePath.replace(/\\/g, '/')}`,
        `file:///${encodeURI(filePath.replace(/\\/g, '/'))}`,

        // 尝试直接使用Blob
      ]

      // 创建测试视频元素
      const container = document.createElement('div')
      container.style.position = 'fixed'
      container.style.top = '0'
      container.style.left = '0'
      container.style.zIndex = '9999'
      container.style.background = 'white'
      container.style.padding = '20px'
      document.body.appendChild(container)

      for (let i = 0; i < testUrls.length; i++) {
        const url = testUrls[i]
        const div = document.createElement('div')
        div.innerHTML = `<h4>测试 ${i + 1}: ${url}</h4>`

        const video = document.createElement('video')
        video.style.width = '300px'
        video.controls = true
        video.src = url
        video.preload = 'metadata'

        video.onloadeddata = () => {
          div.innerHTML += `<span style="color:green">✓ 加载成功</span>`
          console.log(`URL ${i + 1} 成功:`, url)
        }

        video.onerror = (e) => {
          div.innerHTML += `<span style="color:red">✗ 加载失败: ${e.target.error?.code}</span>`
          console.error(`URL ${i + 1} 失败:`, url, e.target.error)
        }

        div.appendChild(video)
        container.appendChild(div)

        // 等待一下再测试下一个
        await new Promise(resolve => setTimeout(resolve, 2000))
      }
    },
    onImageUpload(file) {
      // 展示加载条
      if (this.showLoading) {
        this.loading = this.$loading({
          lock: true,
          text: '正在上传...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      let formData = new FormData()
      formData.append('file', file.file)
      let url = this.action;
      url += this.action.includes("?") ? "&" : "?"
      url += 'isPermanent=' + this.isPermanent;
      this.$http({
        url: url,
        data: formData,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((data) => {
        this.$emit("success", data, file.file);
      }).catch((e) => {
        this.$emit("fail", e, file.file);
      }).finally(() => {
        this.loading && this.loading.close();
      })
    },
    async onChunckUpload(file) {
	  console.log('分片上传=========')
      this.start = new Date().getTime();
      const md5 = await this.calculateMD5(file.file);
      this.$http({
        url: '/file/upload/init',
        data: {uploadId: md5, originalFilename: file.file.name, fileSize: file.file.size, fileType: this.mType,chunkSize:5*1024*1024},
        method: 'post',
      }).then((data) => {
        if (data.url) {
          // this.$emit("success", data, file.file);
          this.$eventBus.$emit("fileUploadSuccess", data, file.file)
        } else {
          this.startFileUpload(file.file, data);
        }
      }).catch((e) => {
        this.$emit("fail", e, file.file);
      }).finally(() => {
        this.loading && this.loading.close();
      })
    },
    async startFileUpload(file, data) {
      try {
		console.log('开始上传=========')
        // 添加到上传列表
        this.$set(this.uploadingFiles, data.uploadId, {
          file,
          fileName: file.name,
          fileSize: file.size,
          progress: 0,
          status: 'uploading'
        })
        const result = await this.fileUploader.uploadFile(file, data)
      } catch (error) {
        console.error('上传失败:', error)
        this.$emit("fail", error, file.file);
      }
    },
    async beforeUpload(file) {
      console.log('---------beforeUpload',file)
      // 校验文件类型
      if (this.fileTypes && this.fileTypes.length > 0) {
        let fileType = file.type;
        let t = this.fileTypes.find((t) => t.toLowerCase() === fileType);
        if (t === undefined) {
          this.$message.error(`文件格式错误，请上传以下格式的文件：${this.fileTypes.join("、")}`);
          return false;
        }
      }
      // 校验大小
      if (this.maxSize && file.size > this.maxSize) {
        this.$message.error(`文件大小不能超过 ${this.fileSizeStr}!`);
        return false;
      }
      if (this.mType === 'video') {
        let vt = await videoThumbnail(file)
        if (vt && vt.thumbnail) {
          // 判断是否在 Electron 环境
          if (window.electronAPI && typeof window.electronAPI.invoke === 'function') {
            file.localCover = await window.electronAPI.invoke('save-base64-image', vt.thumbnail)
          } else {
            // Web 端：直接使用 Base64 字符串（vt.thumbnail 通常就是 base64）
            file.localCover = vt.thumbnail 
          }
        } else {
          console.warn('[FileUpload] videoThumbnail failed, continuing without local cover')
        }
      } else if (this.mType === 'image') {
        let vt = await imageThumbnail(file)
        if (vt && vt.thumbnail) {
          // 判断是否在 Electron 环境
          if (window.electronAPI && typeof window.electronAPI.invoke === 'function') {
            file.localCover = await window.electronAPI.invoke('save-base64-image', vt.thumbnail)
          } else {
            // Web 端：直接使用 Base64 字符串
            file.localCover = vt.thumbnail
          }
        } else {
          console.warn('[FileUpload] imageThumbnail failed, continuing without local cover')
        }
      }

      //获取
      this.$emit("before", file);
      return true;
    },

    // 初始化上传器
    async initializeUploader() {
      this.fileUploader = new FileUploadUtil({
        onProgress: (fileId, status) => {
          console.log('上传进度:', fileId,status)
          status.file.msgInfo.progress=status.progress;
          // 更新文件进度
          this.$set(this.uploadingFiles, fileId, {
            ...this.uploadingFiles[fileId],
            progress: status.progress,
            speed: status.speed,
            remainingTime: status.remainingTime
          })
        },
        onComplete: (fileId, status, result) => {
          // 文件上传完成
          this.onFileUploadComplete(fileId, status, result)
        },
        onError: (fileId, error) => {
          // 文件上传失败
          this.onFileUploadError(fileId, error)
        }
      })
    },
// 文件上传完成
    onFileUploadComplete(fileId, status, result) {
      if (status.file && status.file.msgInfo && status.file.msgInfo.type === this.$enums.MESSAGE_TYPE.VIDEO) {
        console.log('[VIDEO_HLS] ✓ 上传完成 result 字段:', {
          m3u8Url: result && result.m3u8Url,
          m3u8Status: result && result.m3u8Status,
          videoUrl: result && result.videoUrl,
          coverUrl: result && result.coverUrl,
          fileName: result && result.fileName,
          _rawResult: result
        })
      }
      this.$eventBus.$emit("fileUploadSuccess", result, status.file)
    },

    // 文件上传失败
    onFileUploadError(fileId, error) {
      const fileInfo = this.uploadingFiles[fileId]
      if (fileInfo) {
        fileInfo.status = 'failed'
        fileInfo.error = error.message
        this.$eventBus.$emit("handleUploadError", error.message, fileInfo.file);
      }
    },

    calculateMD5(file) {
      return new Promise((resolve, reject) => {
        const chunkSize = 5 * 1024 * 1024; // 5MB
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();

        fileReader.onload = (e) => {
          spark.append(e.target.result);
          currentChunk++;

          if (currentChunk < chunks) {
            loadNext();
          } else {
            const md5 = spark.end();
            resolve(md5)
          }
        };

        fileReader.onerror = () => {
          alert('文件读取错误，请重试');
        };

        const loadNext = () => {
          const start = currentChunk * chunkSize;
          const end = start + chunkSize >= file.size ? file.size : start + chunkSize;

          fileReader.readAsArrayBuffer(file.slice(start, end));
        };

        loadNext();
      })

    },
    async getFile(result) {
      if (result.success) {
        // 将 base64 字符串转换为 Blob
        const byteCharacters = atob(result.data)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: result.mimeType })

        // 创建对象 URL 用于显示或下载
        const url = URL.createObjectURL(blob)
        return url
      } else {
        throw new Error(result.error)
      }
    }

  },
  mounted() {
    this.initializeUploader()
  },
  computed: {
    fileSizeStr() {
      if (this.maxSize > 1024 * 1024) {
        return Math.round(this.maxSize / 1024 / 1024) + "M";
      }
      if (this.maxSize > 1024) {
        return Math.round(this.maxSize / 1024) + "KB";
      }
      return this.maxSize + "B";
    }
  }
}
</script>

<style></style>